module.exports = __webpack_public_path__ + "static/media/swift.0b716c2d.svg";